import authRoles from "core/auth/authRoles";
import NoMatch from "./NoMatch";

const noMatchConfig = {
  component: NoMatch,
  path: "*",
  layout: {
    config: {
      navbar: {
        display: false,
      },
      sidebar: {
        display: false,
      },
      midbar: {
        display: false,
      },
      footer: {
        display: false,
      },
    },
  },
  auth: authRoles.anyOne,
};

export default noMatchConfig;
